<template>
  <v-form
  
    ref='conditionsForm'>
    <v-card
      v-for="(condition, i) in modifyData[modifyIndex].conditions"
      v-bind:key="i"
      class=condCard>
      <div>
        <!-- style='column-count: 2;'> -->
        <v-combobox
          v-model="modifyData[modifyIndex].conditions[i].type"
          :items="types"
          class="inline"
          color="blue-grey lighten-2"
          label="Please select the category of the diagnosis.">
        </v-combobox>
        <v-combobox
          v-if="modifyData[modifyIndex].conditions[i].type !== ''"
          v-model="modifyData[modifyIndex].conditions[i].name"
          :items="getConds(modifyData[modifyIndex].conditions[i].type)"
          class="inline"
          color="blue-grey lighten-2"
          label="Type the diagnosis or select from dropdown.">
        </v-combobox>
      </div>

      <v-text-field
        type="number"
        required
        v-model="condition.age"
        label="Age diagnosed"></v-text-field>

      <v-textarea
        v-model="condition.details"
        :label="`Please add any extra details about this condition.`"></v-textarea>
      <v-btn
        right
        depressed
        class="right white--text"
        color="red"
        @click="remove(condition)">
        Remove condition
      </v-btn>
    </v-card>
    <center>
      <v-btn
        class="padded white--text"
        color="green"
        @click="addCond">
        Add condition
      </v-btn>
    </center>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    modifyData: Array,
    modifyIndex: Number
  },
  components: {
  },
  mounted () {
    for (var i in this.condictions) {
      var buck = this.condictions[i];
      this.types.push(buck.bucket);
    }
  },
  methods: {
    getConds(type) {
      for (var i in this.condictions) {
        var buck = this.condictions[i];
        if (buck.bucket === type) {
          return buck.list;
        }
      }
    },
    remove (item) {
      const index = this.modifyData[this.modifyIndex].conditions.indexOf(item);
      if (index >= 0)
        this.modifyData[this.modifyIndex].conditions.splice(index, 1);
    },
    addCond() {
      var condition = {
        type: '',
        name: '',
        age: '',
        details: ''
      };
      this.modifyData[this.modifyIndex].conditions.push(condition);
    }
  },
  data () {
    return {
      types: []
    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "condictions",
      "dataModel",
      "conditions",
  
      "conditionList"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
